/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes

// reactstrap components
import {
  Alert,
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import Api from "../../components/helpers/Api";

// core components

// index page sections


import {getStats} from "../../components/helpers/StatsHelpers";
import {
  RiBankCardLine
} from "react-icons/ri";
import withNavigateHook from "../../hooks/withNavigationHook";
import SubscriptionDetails from "./SubscriptionDetails";
import SeoNoIndex from "../../components/helpers/SeoNoIndex";

class BillingDetails extends React.Component {
  state = {
    songBookCount: null,
    stripeCustomerId: null,
    loadingAccount: true,
    recoverMode: false,
    memberOnly: false,
    accountError: false,
    portalLoading: false,
    portalError: "",
  };

  constructor(props) {
    super(props);
    getStats.call(this);
  }

  componentDidMount() {
    const recoverMode = new URLSearchParams(window.location.search).get("recover") === "true";
    this.setState({ recoverMode });

    const user = JSON.parse(sessionStorage.getItem("customer"))?.user;
    const role = user?.accountRole;

    if (role === "MEMBER") {
      this.setState({ loadingAccount: false, memberOnly: true });
      return;
    }

    if (role === "OWNER" || role === "ADMIN") {
      Api.get("/api/account/me")
        .then((response) => {
          this.setState({
            stripeCustomerId: response.data.stripeCustomerId,
            loadingAccount: false,
          });
        })
        .catch(() => {
          this.setState({ loadingAccount: false, accountError: true });
        });
      return;
    }

    this.setState({
      stripeCustomerId: user?.externalCustomerId ?? null,
      loadingAccount: false,
    });
  }

  handleManageBilling = () => {
    this.setState({ portalLoading: true, portalError: "" });
    Api.post("/api/billing/portal-session")
      .then((response) => {
        window.location.href = response.data.url;
      })
      .catch((err) => {
        const message = err.response?.data?.message || "Unable to open billing portal. Please try again.";
        this.setState({ portalLoading: false, portalError: message });
      });
  };

  render() {
    return (
      <>
        <SeoNoIndex noindex={true} />

        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>billing details</span>
                      </h1>
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="12">
                      <Card className="card shadow border-0">
                        <CardBody className="py-5">
                          {/*<div className="icon icon-shape icon-shape-primary rounded-circle mb-4">*/}
                          {/*  <i className="ni ni-check-bold" />*/}
                          {/*</div>*/}
                          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                            <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase mb-3 mb-md-0">
                              <RiBankCardLine color='#5e72e4' size="36"/>&nbsp;Billing details
                            </h2>
                            {(() => {
                              const role = JSON.parse(sessionStorage.getItem("customer"))?.user?.accountRole;
                              return (role === "OWNER" || role === "ADMIN") ? (
                                <Button color="primary" href="/your-profile/team">
                                  View your group
                                </Button>
                              ) : null;
                            })()}
                          </div>
                          <p className="description mt-3">
                          </p>
                          {this.state.loadingAccount ? (
                            <div className="py-4 text-center"><Spinner color="primary" /></div>
                          ) : (
                            <>
                              {this.state.recoverMode && (
                                <Alert color="warning">
                                  A payment needs attention. Use Manage billing below to update your payment method. Stripe will retry your payment automatically once your payment method is updated.
                                </Alert>
                              )}
                              {this.state.portalError && (
                                <Alert color="danger">{this.state.portalError}</Alert>
                              )}
                              {this.state.memberOnly && (
                                <Alert color="info" className="mb-4">
                                  Your subscription is managed by your group account. Please contact your group owner or admin to manage billing.
                                </Alert>
                              )}
                              {this.state.accountError && (
                                <Alert color="danger" className="mb-4">
                                  Unable to load billing information. Please try again or contact support.
                                </Alert>
                              )}
                              {this.state.stripeCustomerId && !this.state.memberOnly && (
                                <>
                                  <div className="mb-4">
                                    <Button
                                      color="primary"
                                      onClick={this.handleManageBilling}
                                      disabled={this.state.portalLoading}
                                    >
                                      {this.state.portalLoading ? (
                                        <>
                                          <Spinner size="sm" color="light" /> Opening billing portal
                                        </>
                                      ) : "Manage billing"}
                                    </Button>
                                  </div>
                                  <SubscriptionDetails customerId={this.state.stripeCustomerId} />
                                </>
                              )}
                            </>
                          )}
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        {/*</main>*/}
        
      </>
    );
  }
}

export default withNavigateHook(BillingDetails);
